<style scoped>
.windows-sized {
  height: 100vh;
}
#content {
  background-color: #f8f8f8;
  margin-bottom: 2rem;
  padding-top: 2rem;
  padding-bottom: 8px;
}
</style>
<template>
  <div
    class="fade page-sidebar-fixed page-header-fixed show page-container"
    id="app"
    v-if="!pageOptions.pageEmpty"
    v-bind:class="{
      'page-sidebar-minified': pageOptions.pageSidebarMinified,
      'page-content-full-height': pageOptions.pageContentFullHeight,
      'page-without-sidebar': pageOptions.pageWithoutSidebar,
      'page-with-right-sidebar': pageOptions.pageWithRightSidebar,
      'page-with-two-sidebar': pageOptions.pageWithTwoSidebar,
      'page-with-wide-sidebar': pageOptions.pageWithWideSidebar,
      'page-with-light-sidebar': pageOptions.pageWithLightSidebar,
      'page-with-top-menu': pageOptions.pageWithTopMenu,
      'page-sidebar-toggled': pageOptions.pageMobileSidebarToggled,
      'page-right-sidebar-toggled': pageOptions.pageMobileRightSidebarToggled || pageOptions.pageRightSidebarToggled,
      'has-scroll': pageOptions.pageBodyScrollTop,
    }"
  >
    <Header v-if="pageOptions.pageWithHeader" />
    <TopMenu v-if="pageOptions.pageWithTopMenu" />
    <Sidebar v-if="!pageOptions.pageWithoutSidebar" />
    <SidebarRight v-if="pageOptions.pageWithTwoSidebar" />
    <div id="content" class="content" v-bind:class="{ 'content-full-width': pageOptions.pageContentFullWidth, 'content-inverse-mode': pageOptions.pageContentInverseMode }">
      <router-view></router-view>
      <vue-ins-progress-bar></vue-ins-progress-bar>
    </div>
    <Footer />
  </div>
  <div v-else>
    <router-view></router-view>
    <vue-ins-progress-bar></vue-ins-progress-bar>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
import Sidebar from "@/components/sidebar/Sidebar";
import TopMenu from "@/components/top-menu/TopMenu";
import PageOptions from "@/Options/PageOptions.js";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Sidebar,
    TopMenu,
  },
  data() {
    return {
      pageOptions: PageOptions,
      refCount: 0,
      isLoading: false,
      logoutStatus: false,
    };
  },
  methods: {
    setLoading(isLoading) {
      if (isLoading) {
        this.refCount++;
        this.$swal({
          title: "Loading.....",
        });
        this.$swal.showLoading();
        this.isLoading = true;
      } else if (this.refCount > 0) {
        this.refCount--;
        this.$swal.close();
        this.isLoading = this.refCount > 0;
      }
    },
    logout() {
      this.$store.dispatch("setUser", null);

      this.$store.dispatch("setFilterOptions", null);
      this.$router.push({ path: "/login" });
      sessionStorage.setItem("sessionExpired", "Session has expired. Please Re-Login to the account to Access this Page.");
    },
  },
  async mounted() {
    PageOptions.pageBodyScrollTop = window.scrollY;

    window.addEventListener("scroll", this.handleScroll);

    this.$insProgress.start();

    this.$router.beforeEach((to, from, next) => {
      this.$insProgress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$insProgress.finish();
    });

    var user = this.$store.state.userData.userData;
    if (user) {
      this.$http.defaults.headers.common["Authorization"] = "Bearer " + user.token;
      this.$http.defaults.headers.common["userdata"] = user.user_id;

      // if(user.role == 'USER DEALER') {
      // 	PageOptions.pageWithoutSidebar = true
      // 	this.$router.push({name : 'TeritoryUserDealer'})
      // }
    }

    this.$http.interceptors.request.use(
      (config) => {
        if (!config.url.includes("/api/master/")) this.setLoading(true);
        return config;
      },
      (error) => {
        this.setLoading(false);
        return Promise.reject(error);
      }
    );

    this.$http.interceptors.response.use(
      async (response) => {
        this.setLoading(false);
        //if response is xlsx file, continue request
        if (response.headers["content-type"] == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") return response;
        //if response code is 200, continue request
        if (response.data.code == 200) return response;
        //if response has session / unauthorised problems, logout and delete remaining request
        else if (response.data.code == 13) {
          await this.logout();
          return new Promise(() => {});
        }
        //if every other error response
        else throw new Error(response.data.message);
      },
      async (error) => {
        this.setLoading(false);

        // console.log(error.response);
        if (typeof error.response === "undefined") {
          return Promise.reject("Error");
        } else if (error.response.status == 500) {
          this.$swal.fire({
            title: "Internal Server Error!",
            text: `We appologize deeply for the interruption, we are experiencing problems. Please contact our support team immediately. Error Code: 500`,
            type: "warning",
          });
          return Promise.reject(error);
        } else if (error.response.status == 401) {
          //Unauthorized: session is invalid, logout and drop the request
          await this.logout();
          return new Promise(() => {});
        } else if (error.response.status == 403) {
          //Forbidden: session is valid but lacks permission, let the caller handle it
          return Promise.reject(error);
        }

        return Promise.reject(error);
      }
    );

    await this.loadFilterOptions();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.stats-outer-box {
  padding: 20px;
}

.stats-inner-box {
  border-radius: 10px;
  background-color: #348fe2;
  height: 85px;
}

.stats-inner-box p,
.stats-inner-box h2 {
  color: white;
}
.stats-inner-box p {
  margin: 5% 0 0 12.5%;
}
.stats-inner-box .stats-value {
  margin-top: 0;
  margin-left: 10%;
  font-size: 2em;
  font-weight: 500;
}
.stats-inner-box .stats-value .stats-value-support {
  font-size: 0.5em;
  font-weight: normal;
}
.stats-inner-box h2 {
  margin-left: 10%;
}
.stats-inner-box .icon {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.stats-inner-box .icon i {
  color: #00000050;
  font-size: 3em;
}

.outer-box {
  padding: 20px;
}
.inner-box {
  border-radius: 10px;
  background-color: #fff;
  padding: 20px;
  height: 85px;
}

/* FLATPICKR CUSTOM CSS START */
input[readonly].flatpickr-input {
  background-color: #fff !important;
  height: 43px;
}
/* FLATPICKR CUSTOM CSS END */
table.tableBodyScroll tbody {
  display: block;
  max-height: 400px;
  overflow-y: scroll;
}

table.tableBodyScroll thead,
table.tableBodyScroll tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.wrapHighlight .multiselect__single {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wrapHighlight .multiselect__placeholder {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.button-new-1 {
  background-color: #f36f21;
  border-color: #f36f21;
  border-width: 1px;
  border-radius: 4px;
  color: white;
}

.button-new-1:hover {
  color: white;
}

.button-new-2 {
  border-color: #f36f21;
  border-width: 1px;
  border-radius: 4px;
  color: #f36f21;
}

.button-new-2:hover {
  color: #f36f21;
}
</style>
